import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useDispatch } from 'react-redux';
// import PrivateRoute from './components/PrivateRoute/PrivateRoute';
import './App.css';
// Toast notifications
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { setCredentials } from './store/slices/authSlice';
import Login from './pages/Login/Login';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import VerifyCode from './pages/VerifyCode/VerifyCode';
import ResetPassword from './pages/ResetPassword/ResetPassword';
//Home
import DashboardLayout from './layouts/DashboardLayout';
import Home from './pages/Dashboard/Home';
//Profile
import UserProfile from './pages/MenuOptions/Profile/UserProfile';
import ChangePassword from './pages/MenuOptions/Profile/ChangePassword/ChangePassword';
//Roles
import Roles from './pages/MenuOptions/Roles/Roles';
import NewRole from './pages/MenuOptions/Roles/NewRole';
import EditRole from './pages/MenuOptions/Roles/EditRole/EditRole';
//User Management
import UserManagement from './pages/MenuOptions/UserManagement/UserManagement';
import NewUser from './pages/MenuOptions/UserManagement/NewUser/NewUser';
// Tokens
import Tokens from './pages/MenuOptions/Tokens/Tokens'; 
import AddToken from './pages/MenuOptions/Tokens/AddToken/AddToken';
import SupportTokens from './pages/MenuOptions/Tokens/SupportTokens/SupportTokens';
//Customers
import Customers from './pages/MenuOptions/Customers/Customers';
import InfoCustomer from './pages/MenuOptions/Customers/InfoCustomer/InfoCustomer';
import DetailRequest from './pages/MenuOptions/Customers/InfoCustomer/RequestHistory/DetailRequest/DetailRequest';
import DetailtService from './pages/MenuOptions/Customers/InfoCustomer/ServiceHistory/DetailtService/DetailtService';
import DetailSupport from './pages/MenuOptions/Customers/InfoCustomer/Support/Actions/DetailSupport/DetailSupport';
import CheckSupport from './pages/MenuOptions/Customers/InfoCustomer/Support/Actions/CheckSupport/CheckSupport';
import DetailsGroup from './pages/MenuOptions/Customers/InfoCustomer/GroupsCustomer/DetailsGroup/DetailsGroup';
//Groups
import GroupsManagement from './pages/MenuOptions/GroupsManagement/GroupsManagement';
import AddGroup from './pages/MenuOptions/GroupsManagement/AddGroup/AddGroup';
import DetailsGroups from './pages/MenuOptions/GroupsManagement/DetailsGroup/DetailsGroup';
import MemberData from './pages/MenuOptions/GroupsManagement/DetailsGroup/InfoGroup/Members/MemberData/MemberData';
import ServiceOfferedDetail from './pages/MenuOptions/GroupsManagement/DetailsGroup/InfoGroup/ServiceOffered/ServiceOfferedDetail/ServiceOfferedDetail';
import SupportGroupData from './pages/MenuOptions/GroupsManagement/DetailsGroup/InfoGroup/SupportGroup/SupportGroupData/SupportGroupData';
//Support
import SupportList from './pages/MenuOptions/Support/SupportList';
//Payments
import PaymentMethod from './pages/Payments/PaymentMethod/PaymentMethod';
import PurchaseBucks from './pages/Payments/PurchaseBucks/PurchaseBucks';
import SuccessfulPurchase from './components/SuccessfulPurchase/SuccessfulPurchase';
//Notifications
import Notifications from './pages/Notifications/Notifications';
//Configurations
import Configurations from './pages/MenuOptions/Configurations/Configurations';
import AddSuggestedPrice from './pages/MenuOptions/Support/SuggestedPrice/AddSuggestedPrice/AddSuggestedPrice';

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    // Verificar tokens al inicio
    const accessToken = localStorage.getItem('accessToken');
    const refreshToken = localStorage.getItem('refreshToken');
    
    if (accessToken && refreshToken) {
      dispatch(setCredentials({ accessToken, refreshToken }));
    }
  }, [dispatch]);

  return (
    <Router>
      <div className="App">
        {/* Toast Container para notificaciones */}
        <ToastContainer 
          containerId="global"
          position="top-right" 
          autoClose={5000} 
          hideProgressBar={false} 
          newestOnTop 
          closeOnClick 
          rtl={false} 
          pauseOnFocusLoss 
          draggable 
          pauseOnHover 
        />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/verify-code" element={<VerifyCode />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Payments Routes */}
          <Route path="/payments/payment-method/:token/:language" element={<PaymentMethod />} />
          <Route path="/payments/purchase-bucks/:token/:language" element={<PurchaseBucks />} />
          <Route path="/payments/successful-purchase" element={<SuccessfulPurchase />} />
          
          {/* Dashboard Routes */}
          <Route path="/dashboard" element={
            <DashboardLayout />
          }>
            <Route index element={<Home />} />
            {/* Roles */}
            <Route path="roles" element={<Roles />} />
            <Route path="role/new-role" element={<NewRole />} />
            <Route path="role/edit-role/:id" element={<EditRole />} />
            {/* Tokens */}
            <Route path="tokens" element={<Tokens />} />
            <Route path="tokens/new-token" element={<AddToken />} />
            <Route path="tokens/edit-token/:id" element={<AddToken />} />
            <Route path="tokens/support-token" element={<SupportTokens />} />
            {/* Stats */}
            <Route path="stats" element={<div>Dashboard Stats</div>} />
            {/* Help */}
            <Route path="help" element={<div>Help</div>} />
          </Route>
          {/* Profile */}
          <Route path="/profile"element={
            <DashboardLayout />
          }>
            <Route index element={<UserProfile />} />
            <Route path="change-password" element={<ChangePassword />} />
          </Route>
          {/* Users */}
          <Route path="/users"element={
            <DashboardLayout />
          }>
            <Route index element={<UserManagement />} />
            <Route path="new-user" element={<NewUser />} />
            <Route path="edit-user/:id" element={<NewUser />} />
          </Route>
          {/* Groups */}
          <Route path="/groups" element={
            <DashboardLayout />
          }>
            <Route index element={<GroupsManagement />} />
            <Route path="new-group" element={<AddGroup />} />
            <Route path="edit-group/:id" element={<AddGroup />} />
            <Route path="group-details/:id" element={<DetailsGroups />} />
            <Route path="group-details/member/:id" element={<MemberData />} />
            <Route path="group-details/service/:id" element={<ServiceOfferedDetail />} />
            <Route path="group-details/support/:id" element={<SupportGroupData />} />
            <Route path="groups/support/:id" element={<SupportGroupData />} />
          </Route>
          {/* Support */}
          <Route path="/support" element={
            <DashboardLayout />
          }>
            <Route index element={<SupportList />} />
            <Route path="details/:supportId" element={<DetailSupport />} />
            <Route path="assign/:supportId" element={<DetailSupport />} />
            <Route path="check/:supportId" element={<CheckSupport />} />
          </Route>
          {/* Customers */}
          <Route path="/customers" element={
            <DashboardLayout />
          }>
            <Route index element={<Customers />} />
            <Route path="info-customer/:id" element={<InfoCustomer />} />
            <Route path="request-history/:requestId" element={<DetailRequest />} />
            <Route path="service-history/:serviceId" element={<DetailtService />} />
            <Route path="support/:supportId" element={<DetailSupport />} />
            <Route path="support/check/:supportId" element={<CheckSupport />} />
            <Route path="groups/:groupId" element={<DetailsGroup />} />
          </Route>
          {/* Notifications */}
          <Route path="/notifications"element={
            <DashboardLayout />
          }>
            <Route index element={<Notifications />} />
          </Route>
          {/* Configurations */}
          <Route path="/configurations"element={
            <DashboardLayout />
          }>
            <Route index element={<Configurations />} />
            <Route path="suggested-price/new" element={<AddSuggestedPrice />} />
            <Route path="suggested-price/edit/:id" element={<AddSuggestedPrice />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
